import { writable, get, derived } from 'svelte/store';
import { emails } from '../constants';

export const idToken = createStore(null);

function createStore() {
    const { subscribe, set, update } = writable(null);

    return {
        subscribe,
        set,
        update
    };
}

export const isAdmin = derived(idToken, $idToken => {
    return $idToken && emails.includes($idToken.email);
});
